import ROUTES from "~/kernel/routing/ROUTES";
import { useTranslation } from "react-i18next";
import NavigationLink from "./NavigationLink";
import Icon from "./Icon";
import { useRepresentationContext } from "~/kernel/auth/useRepresentationContext";
import { RepresentationType } from "~/kernel/auth/determineRepresentation";

export function SettingsButton() {
  const representation = useRepresentationContext();
  const { t } = useTranslation();

  switch (representation.type) {
    case RepresentationType.Company:
      return (
        <NavigationLink
          activatable
          to={ROUTES.editUserCompany.path()}
          ariaLabel={t("nav.settings")}
        >
          <Icon name="gear" className="text-2xl md:!text-xl" />
        </NavigationLink>
      );
    case RepresentationType.Customer:
      return (
        <NavigationLink
          activatable
          to={ROUTES.customerHomeSettings.path()}
          ariaLabel={t("nav.settings")}
        >
          <Icon name="gear" className="text-2xl md:!text-xl" />
        </NavigationLink>
      );
    default:
      return null;
  }
}
